import { notifications } from '@utils/notifications';
import { useCallback, useState } from 'react';

const COPY_TOAST_ID = 'clipboard-copy';

const useClipboard = ({
  text,
  notificationText
}: {
  text?: string | null;
  notificationText?: string;
} = {}): {
  isCopied: boolean;
  copyPromocode: (override?: unknown) => void;
} => {
  const [isCopied, setIsCopied] = useState(false);
  const copyPromocode = useCallback(
    (override?: unknown) => {
      const value = typeof override === 'string' ? override : text;
      if (!value || !navigator?.clipboard?.writeText) {
        return;
      }
      navigator.clipboard
        .writeText(value)
        .then(() => {
          setIsCopied(true);
          notifications(
            notificationText || `Промокод ${value} скопирован!`,
            '',
            undefined,
            COPY_TOAST_ID
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    [notificationText, text]
  );
  return {
    isCopied,
    copyPromocode
  };
};

export default useClipboard;
